import { jsx } from "react/jsx-runtime";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import ZillowResearchLogo from "./assets/zillow-economic-research.svg.esm.js";
import { HEADER_CTAS, FOOTER_COLUMNS, LAYOUT_MENU_ITEMS } from "./constants/layout.esm.js";
const LOGO_WIDTH = 119;
const LOGO_HEIGHT = 15;
const ZillowResearchLayout = ({
  children,
  submenu,
  header,
  router,
  environment
}) => {
  const img = {
    src: ZillowResearchLogo,
    alt: "Zillow Research",
    width: LOGO_WIDTH,
    height: LOGO_HEIGHT,
    blurHeight: 0,
    blurWidth: 0,
    link: "/research/"
  };
  return /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInLink: "/user/Login.htm", signInRedirectParam: "redirect", logo: img, menu: LAYOUT_MENU_ITEMS, submenu, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, footerColumns: FOOTER_COLUMNS, primaryCTALink: HEADER_CTAS.primary.url, primaryCTALabel: HEADER_CTAS.primary.label, secondaryCTALink: HEADER_CTAS.secondary.url, secondaryCTALabel: HEADER_CTAS.secondary.label, sticky: true, children });
};
export {
  ZillowResearchLayout as default
};
